import { Certification } from "./Certification";

import { Column } from "@/components/Column";
import { SheetSectionEmptyText } from "@/components/SheetSectionEmptyText";
import { CertificationType } from "@/types";

export const CertificationsView = ({
  certifications,
}: {
  certifications: CertificationType[];
}) => {
  if (!certifications.length) {
    return (
      <SheetSectionEmptyText text="This candidate hasn't added any certifications." />
    );
  }

  return (
    <Column className="gap-4">
      {certifications.map((certification: CertificationType) => (
        <Certification certification={certification} key={certification.id} />
      ))}
    </Column>
  );
};
